import useKyc from 'hooks/requests/kyc/useKyc';

const useFullName = () => {
  const { kycIdentities } = useKyc();
  const firstName = kycIdentities?.attributes?.first_name;
  const middleName = kycIdentities?.attributes?.middle_name;
  const lastName = kycIdentities?.attributes?.last_name;

  let fullName = '';

  if (firstName) {
    fullName += firstName + ' ';
  }
  if (middleName) {
    fullName += middleName + ' ';
  }
  if (lastName) {
    fullName += lastName;
  }

  return fullName;
};

export default useFullName;
